<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pMmHQD/tc-custom/9781936932283.jpg?1705262173192" alt="This image is the cover for the book Love War Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love War Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>“Arrests the heart with its stunning exploration of women who are put through a kind of hell in their determination to find true love . . . extraordinary.” —Angie Cruz, author of<i> Dominicana</i></b><br/><br/><b>Finalist for the 2019 PEN/Faulkner Award for Fiction</b><br/><br/><b>Finalist for the 2018 Foreword Reviews INDIES Award</b><br/><br/><b>Best Book/Most Anticipated Book/Recommended Read of 2018: <i>Cosmopolitan.com</i>, <i>The Root</i>, <i>Electric Literature</i>, <i>Bustle</i>, <i>Book Riot</i>, PEN America, <i>PopSugar</i>, <i>The Rumpus</i>, <i>B*tch</i>, <i>Remezcla</i>, Mitú, and other publications.</b><br/><br/>Puerto Rican girls are brought up to want one thing: true love. Yet they are raised by women whose lives are marked by broken promises, grief, and betrayal. While some believe that they’ll be the ones to finally make it work, others swear not to repeat cycles of violence. This collection documents how these “love wars” break out across generations as individuals find themselves caught in the crosshairs of romance, expectations, and community.<br/><br/><b>“A tough smart dazzling debut by a tough smart dazzling writer. Ivelisse Rodriguez is a revelation.” —Junot Díaz, Pulitzer Prize-winning author of<i> This Is How You Lose Her</i></b><br/><br/><b>“[An] exceptional collection of short stories . . . Filled with memorable characters and sharp writing, this book will leave you breathless.” —<i>Bustle</i></b><br/><br/><b>“Rodriguez conceives exquisite misery and makes alchemy of hopelessness in her debut short story collection.” —<i>Electric Literature</i></b><br/><br/><b>“[A] perceptive exploration of love, heartbreak, and womanhood.” —<i>The Seattle Review of Books</i></b><br/><br/><b>“This reviewer kept returning to [these stories] for their freshness, urgency, and sheer heart.” —<i>Library Journal</i></b><br/><br/><b>“Throughout the collection, Rodriguez’s prose pulls you in, and her characters will stay with you even when the stories are only a few pages long.” —<i>BUST</i></b><br/><br/><b>“Both heartbreaking and insightful.” —<i>Publishers Weekly</i></b><br/><br/><b>“Stunning.” —<i>MyDomaine</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ivelisse Rodriguez
      </h2>
      
      <p class="authorDescription body article">Born in Arecibo, Puerto Rico, Ivelisse Rodriguez earned a PhD in English creative writing from the University of Illinois at Chicago and an MFA from Emerson College. She has published fiction in <I>All about Skin: Short Fiction by Women of Color</I>, <I>Kweli</I>, the <I>Boston Review</I>, the <I>Bilingual Review</I>, and others. She is a senior fiction editor at <I>Kweli</I>, a Kimbilio fellow, and a VONA/Voices alum.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Feminist Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35d22f4e